module.exports = __webpack_public_path__ + "img/arr-dark.fdae85a4.svg";